export const SplitByCommaElement = ({ text }) => {
  const parts = text.split(",");
  return (
    <div>
      {parts.map((part, index) => (
        <div key={index}>{part.trim()}</div>
      ))}
    </div>
  );
};
